export function isValueOutOfRange(value: number, { min, max}: any) {
  return value < min || value > max;
}

export function isNotTouchEvent(e: TouchEvent) {
  return e.touches.length > 1 ||
    (e.type.toLowerCase() === 'touchend' && e.touches.length > 0);
}

export function getTouchPosition(e: TouchEvent) {
  return e.touches[0].pageX;
}

export function getMousePosition(e: MouseEvent) {
  return e.clientX;
}

export function calculateClickOffset(e: any) {
  const position = getMousePosition(e);
  const handlePosition = e.target.offsetLeft;
  return position - handlePosition;
}

export function calculateTouchOffset(e: any) {
  const position = getTouchPosition(e);
  const handlePosition = e.target.offsetLeft;
  return position - handlePosition;
}

export function findClosestCenter(arrayOfElements: any[], currentElement: any) {
  if (!Array.isArray(arrayOfElements) || arrayOfElements.length === 0) {
    return 0;
  }
  return arrayOfElements.reduce((prev, curr) =>
    Math.abs(curr - currentElement) < Math.abs(prev - currentElement) ? curr : prev
  );
}

export function calculateSegmentCenters(width: number, segmentCount:number, offset?:number): number[] {
  const segmentWidth = width / segmentCount;
  const centerOffset = segmentWidth/2;
  const offsetValue = offset || 0;
  // tslint:disable-next-line: prefer-array-literal
  const rtn:number[] = new Array(segmentCount);

  for(let i = 0; i < segmentCount; i++) {
    rtn[i] = Math.floor((i*segmentWidth)+centerOffset+offsetValue);
  }

  return rtn;
}

export function calculateCenters(node: HTMLElement, circleWidth: number) {
  return !node ?  {crossPoints: [], sum: 0} : [].reduce.call(node.childNodes, (prev, currentNode) => {
    prev.crossPoints.push(currentNode.offsetWidth / 2 + prev.sum - circleWidth);
    prev.sum = prev.sum + currentNode.offsetWidth;
    return prev;
  }, {crossPoints: [], sum: 0}).crossPoints;
}
